module.exports = __webpack_public_path__ + "static/media/192.6532e0d2.jpg";